<template>
    <p>
        {{data.lines.data[0].period.start | secondsToDateMonthDay}} - {{data.lines.data[0].period.end | secondsToDateMonthDay}}
    </p>
</template>

<script>
import {dates} from '../../../../../core/filters'
export default {
    name: "InvoiceDates",
    props: {
        data: Object
    },
    filters: {
        secondsToDateMonthDay: dates.secondsToDateMonthDay
    },
}
</script>